import { keepPreviousData, useQuery } from "@tanstack/react-query";

import { quotaQueryKeys } from "app/pages/sales-intelligence/modules/quota/queries/keys";
import salesApiService from "app/pages/sales-intelligence/services/salesApiService";
import salesSettingsHelper from "app/pages/sales-intelligence/services/salesSettingsHelper";

import type { DataCreditsStateDto } from "../types";

type HookParams<TData = DataCreditsStateDto> = {
    enabled?: boolean;
    select?: (data: DataCreditsStateDto) => TData;
};

export const useDataCreditsQuery = <TData = DataCreditsStateDto>({ enabled, select }: HookParams<TData> = {}) => {
    return useQuery<DataCreditsStateDto, Error, TData>({
        enabled: enabled ?? salesSettingsHelper.isDataCreditsEnabled,
        queryKey: quotaQueryKeys.dataCredits(),
        queryFn({ signal }) {
            return salesApiService.quota.fetchDataCreditsState({ cancellation: signal });
        },
        placeholderData: keepPreviousData,
        staleTime: Number.POSITIVE_INFINITY,
        select,
    });
};
